<script>
  import Page from '@components/page.svelte'
  import FilterBar from '@components/table/filter-bar.svelte'
  import Pagination from '@components/table/pagination.svelte'
  import Dropdown from '@components/general/dropdown.svelte'
  import GridView from '@components/resources/grid-view.svelte'
  import { usePageParam } from '@hooks/use-page-param.svelte'
  import { FileDown, ClockArrowDown, ClockArrowUp, ArrowUpAZ, ArrowDownZA, Lock, Unlock, CheckCheck, Settings, Tag as TagIcon } from 'lucide-svelte'
  import { page } from '@inertiajs/svelte'

  let { resources = [], pagination, tags = [] } = $props()

  let user = $page.props.user

  let tagOptions = $derived.by(() => {
    const emptyOption = { value: "", label: "All topics", icon: TagIcon }
    let options = tags.filter(t => t.count > 0).map(t => ({ value: t.id, label: `${t.name} (${t.count})`, icon: TagIcon }))
    return [emptyOption, ...options]
  })

  let tag = usePageParam({ key: "tag", items: tagOptions })

  let access = usePageParam({ key: "access", defaultValue: "all", items: [
    { value: "free", label: "Free resources", icon: Unlock },
    { value: "premium", label: "Premium resources", icon: Lock },
    { value: "all", label: "All resources", icon: CheckCheck },
  ] })

  let sort = usePageParam({ key: "sort", defaultValue: "newest", items: [
    { value: "newest", label: "Most recent", icon: ClockArrowDown },
    { value: "oldest", label: "Oldest", icon: ClockArrowUp },
    { value: "az", label: "Alphabetical A-Z", icon: ArrowUpAZ },
    { value: "za", label: "Alphabetical Z-A", icon: ArrowDownZA }
  ]})

  let pageProps = {
    pageTitle: "Our Resources",
    title: "Our Resources",
    subtitle: "Curated resources created each month",
    Icon: FileDown,
    adminActions: [
      { text: "Manage", path: "/admin/resources", icon: Settings }
    ]
  }
</script>

<Page {...pageProps}>

  <FilterBar {pagination} paginationProps={{ summary: true, terms: ["resource", "resources"] }}>
    {#snippet filters()}

      <!-- Sort -->
      <Dropdown buttonProps={{ text: sort.label, Icon: sort.icon, variant: "outline", size: "md" }} width="12rem" align="start" itemSize="md">
        {#snippet contents(item)}
          {#each sort.items as sortItem (sortItem.value)}
            {@render item({ text: sortItem.label, icon: sortItem.icon, onSelect: () => sort.setValue(sortItem.value) })}
          {/each}
        {/snippet}
      </Dropdown>

      <!-- Tag filter -->
      {#if tags.length > 0}
        <Dropdown buttonProps={{ text: tag.label, Icon: TagIcon, variant: "outline", size: "md" }} width="16rem" align="start" itemSize="md">
          {#snippet contents(item)}
            {#each tag.items as tagItem (tagItem.value)}
              {@render item({ text: tagItem.label, icon: tagItem.icon, onSelect: () => tag.setValue(tagItem.value) })}
            {/each}
          {/snippet}
        </Dropdown>
      {/if}

      <!-- Access filter (only show for non-premium users) -->
      {#if !user?.has_active_membership}
        <Dropdown buttonProps={{ text: access.label, Icon: access.icon, variant: "outline", size: "md" }} width="12rem" align="start" itemSize="md">
          {#snippet contents(item)}
            {#each access.items as accessItem (accessItem.value)}
              {@render item({ text: accessItem.label, icon: accessItem.icon, onSelect: () => access.setValue(accessItem.value) })}
            {/each}
          {/snippet}
        </Dropdown>
      {/if}

    {/snippet}
  </FilterBar>
  
  <GridView {resources} />

  <Pagination {pagination} paginationProps={{ summary: true, terms: ["resource", "resources"] }} />

</Page>
